<template>
  <div class="content">
    <div>
      <h2 class="page-title">アカウント一覧</h2>

      <section id="setting-company-list">
        <div class="px-3">
          <div class="ml-md-3 mb-4 search-wrapper">
            <div>
              <label
                class="d-md-inline pt-2 col-md-4 col-lg-2 text-left px-0 my-0"
              >
                お名前
              </label>
              <input
                type="text"
                class="d-inline form-control col-md-3"
                v-model="search.name"
                @change="setAccount()"
              />
              <label
                class="
                  d-md-inline
                  col-md-4 col-lg-2
                  text-left
                  px-0
                  pl-md-4
                  my-0
                  mt-2 mt-md-0
                "
              >
                メールアドレス
              </label>
              <input
                type="email"
                class="d-inline form-control col-md-3"
                v-model="search.mail"
                @change="setAccount()"
              />
            </div>
          </div>

          <div v-if="async.accounts" class="spinner">
            <md-progress-spinner md-mode="indeterminate" />
          </div>
          <div v-else>
            <md-table
              v-if="accounts.length"
              v-model="accounts"
              md-sort="USER_ID"
              md-sort-order="asc"
              md-card
              class="mb-4 p-2 bg-gray mx-0"
            >
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell
                  md-label="ID"
                  md-sort-by="USER_ID"
                  :class="{ 'bg-blue white': isMobile }"
                >
                  <span v-if="!isMobile">{{ omitText(item.USER_ID, 30) }}</span>
                  <div v-else class="row mx-0">
                    <p class="col-5 bold">ID</p>
                    <p class="col-7">{{ item.USER_ID }}</p>
                  </div>
                </md-table-cell>

                <md-table-cell md-label="お名前" md-sort-by="name">
                  <span v-if="!isMobile">{{ omitText(item.name, 23) }}</span>
                  <div v-else class="row mx-0">
                    <p class="col-5 bold blue">お名前</p>
                    <p class="col-7">{{ item.name }}</p>
                  </div>
                </md-table-cell>

                <md-table-cell md-label="メールアドレス" md-sort-by="email">
                  <span v-if="!isMobile">{{ omitText(item.email, 45) }}</span>
                  <div v-else class="row mx-0">
                    <p class="col-5 bold blue">メールアドレス</p>
                    <p class="col-7">{{ item.email }}</p>
                  </div>
                </md-table-cell>

                <md-table-cell md-label="ステータス" md-sort-by="status">
                  <span
                    v-if="!isMobile"
                    :class="[{ red: isCheckRestrict(item.STATUS) }]"
                  >
                    {{ accountStatus[item.STATUS] }}
                  </span>
                  <div v-else class="row mx-0">
                    <p
                      :class="[
                        'col-5 bold blue',
                        { red: isCheckRestrict(item.STATUS) },
                      ]"
                    >
                      ステータス
                    </p>
                    <p class="col-7">{{ accountStatus[item.STATUS] }}</p>
                  </div>
                </md-table-cell>

                <md-table-cell md-label="" class="text-right">
                  <b-button
                    v-if="!isCheckRestrict(item.STATUS)"
                    class="btn-success detail-btn sp-fs-14"
                    @click="gotoEdit(item)"
                  >
                    編集
                  </b-button>
                  <b-button
                    v-if="!isCheckRestrict(item.STATUS)"
                    class="btn-secondary detail-btn sp-fs-14"
                    @click="
                      deleteItem = item
                      isDeleteConfirm = true
                    "
                  >
                    削除
                  </b-button>
                </md-table-cell>
              </md-table-row>
            </md-table>
            <div v-else class="text-center my-5 bold">
              該当データがありません。
            </div>
          </div>
        </div>
      </section>

      <div class="text-center mr-3 mr-md-0">
        <md-button
          type="button"
          class="btn-lg btn-secondary base-btn col-md-3 col-lg-2"
          :to="{ name: 'SettingIndex' }"
        >
          もどる
        </md-button>
      </div>
    </div>

    <!-- 削除確認 -->
    <md-dialog-confirm
      class="new"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
      :md-active.sync="isDeleteConfirm"
      md-title=""
      md-content="<strong>削除してもよろしいですか？</strong>"
      md-confirm-text="はい"
      md-cancel-text="いいえ"
      @md-confirm="deleteAccount()"
      @md-cancel="delreset"
    />
    <md-dialog-alert
      class="new"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
      :md-active.sync="isDeleted"
      md-content="<strong>削除しました。</strong>"
    />
  </div>
</template>

<script>
import Mixin from '../../mixin/Mixin'
import Constant from '@/const'
import Store from '@/store/index.js'

const MAX_TABLE_RECORD = 10 // テーブルにスクロールしないで表示するレコード数の最大値
const ROW_HEIGHT = 65

export default {
  name: 'Edit',
  components: {},
  mixins: [Mixin],
  data: () => ({
    async: {
      accounts: false,
    },
    isDeleted: false,
    isSaved: false,
    isDeleteConfirm: false,
    accounts: [],
    deleteItem: {}, // 削除アカウント
    search: {
      name: '',
      mail: '',
      from: '',
      to: '',
    },
  }),
  methods: {
    /**
     * アカウント取得
     */
    setAccount() {
      this.search.jyucyu_shiki_cd = Store.state.user.data.JYUCYU_SHIKI_CD
      this.async.accounts = true
      this.getAccount(this.search)
        .then((res) => {
          this.accounts = res.data
          this.async.accounts = false
        })
        .catch((err) => {
          this._alert(err.message, false)
        })
    },
    /**
     * 削除アカウント設定
     */
    delset(item) {
      this.mdlAccount.ID = item.TANTO_ID
      this.mdlAccount.STATUS = item.STATUS
    },
    /**
     * 削除アカウントリセット
     */
    delreset() {
      this.mdlAccount.ID = ''
      this.mdlAccount.STATUS = ''
    },
    changePassword() {
      this.mdlAccount.NEW_PASSWORD = this.mdlAccount.PASSWORD
    },
    /**
     * アカウント削除
     */
    deleteAccount() {
      this.spinerOn()
      let url = ''
      let _this = this
      this.deleteItem.ID = this.deleteItem.TANTO_ID
      if (this.deleteItem.STATUS !== Constant.USER.STATUS.INITIAL) {
        url = 'account/updateAccount'
        this.deleteItem.DELETE_NICHIJI = this.getNichiji()
      } else {
        url = 'account/delAccount'
      }
      return this.$store
        .dispatch(url, this.deleteItem)
        .then((res) => {
          this.spinerOff()
          // 自分のアカウントを削除する場合はログアウト
          if (Store.state.user.data.ID === _this.deleteItem.TANTO_ID) {
            _this.logout()
          } else {
            this.spinerOff()
            this.setAccount()
            this.isDeleted = true
          }
        })
        .catch((err) => {
          this.spinerOff()
          this._alert(err.message, false)
        })
    },
    gotoEdit(item) {
      const account = {
        ID: item.TANTO_ID,
        USER_ID: item.USER_ID,
        STATUS: item.STATUS,
        SOFU_SAKI_MEI: item.SOFU_SAKI_MEI,
        TANTO_MEI_SEI: item.TANTO_MEI_SEI,
        TANTO_MEI: item.TANTO_MEI,
        MAIL_ADDR: item.MAIL_ADDR,
        TEHAI_KANRYO_MAIL: item.TEHAI_KANRYO_MAIL,
        NOSYA_KANRYO_MAIL: item.NOSYA_KANRYO_MAIL,
        FROM_PAGE: 'SettingCompanyIndex',
      }
      Store.commit('setting/create', account)
      this.$router.push({ name: 'SettingEdit' })
    },
    // 仕様不可ステータスか判定
    isCheckRestrict(status) {
      return status === Constant.USER.STATUS.RESTRICT
    },
  },
  computed: {
    // モーダル表示中ユーザが非アクティベートユーザが判定
    isInitialAccount() {
      return this.mdlAccount.STATUS === Constant.USER.STATUS.INITIAL
    },
  },
  created() {
    this.setAccount()
  },
}
</script>

<style lang="sass" scoped>
@import '../../../assets/css/logico2'
table
  margin: 0
  th
    background: $baseBlueColor
    color: #fff
    width: 32%
    padding: 1.5%
  td
    width: 68%
    background: #fff
section#setting-company-list
  .detail-btn
    font-weight: bold
    color: white
</style>



// WEBPACK FOOTER //
// src/components/setting/company/Index.vue